<!-- 服务流程 -->
<template>
<div class="info-block">
  <ul>
    <li v-for="(info,index) in infoList" :key="index">
      <router-link :to="{path: '#'}" class="info-block-a" v-if="info.order!=''">
        <div class="title"><span>{{index<9?'0':''}}{{index+1}}</span>{{info.title}}</div>
        <div class="label">{{info.label}}</div>
        <div class="content">{{info.content}}</div>
      </router-link>
    </li>
  </ul>
</div>
</template>
<script>
export default {
  name: 'FwlcInfo1',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      infoList:[]
    }
  },
  created:function(){
    this.infoList=this.Global.kjfwServiceFlow;
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}

li {
  width: 100%;
  margin: 0px 0px 2px 0px;
  padding:0px 0px 10px 4px;
  height:140px;
}

.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:140px;
  padding:0px 0px 0px 0px;
  margin:0px 0px 0px 0px;
  //background-color:green;
  //border:1px solid #eee;
  background-image:url(./../../assets/fwlc_01.png);
  background-size: 40px 130px;
  background-repeat: no-repeat;
  background-position: 0px 10px;
}

li:last-child > .info-block-a{
  background-size: 0px 0px;
  background-repeat: no-repeat;
  background-position: 0px 30px;
}

.info-block .info-block-a:hover > .title{
  color: var(--color6)
}

.info-block .info-block-a:hover > .label{
  color: var(--color6)
}

.info-block-a .title{
  position:relative;
  height:20px;
  width:100%;
  font-size:14px;
  font-weight:600;
  line-height:20px;
  color:#000;
}

.info-block-a .title span{
  display:block;
  float:left;
  height:20px;
  width:40px;
  font-size:14px;
  font-weight:600;
  line-height:20px;
  //background:yellow;
  text-align:center;
}

.info-block-a .label{
  position:relative;
  height:20px;
  width:100%;
  font-size:12px;
  font-weight:600;
  line-height:10px;
  padding-left:40px;
}

.info-block-a .content{
  position:relative;
  width:100%;
  font-size:12px;
  line-height:20px;
  padding-left:40px;
  padding-right:20px;
  color:#bbbbbb;
}

.div-1{
  position:relative;
  height:280px;
  width:100%;
  padding:150px 0px 0px 0px;
  //background:var(--color6);
  color:#fff;
  background-size: auto 150px;
  background-repeat: no-repeat;
  background-position: 0px 0px;
}

.div-1-1{
  height:40px;
  padding:10px;
  font-size:14px;
  font-weight:600;
  text-align:left;
  color:#515151;
}

.div-1-2{
  height:25px;
  padding:0px 10px 10px 10px;
  font-size:12px;
  font-weight:100;
  text-align:left;
  line-height:15px;
  color:var(--color7);
  //background:yellow;
}

.div-1-3{
  height:25px;
  padding:0px 10px 5px 25px;
  font-size:12px;
  font-weight:100;
  text-align:left;
  line-height:15px;
  color:var(--color7);
  //background:red;
}

.div-1-3 .td-action-1{
  display:block;
  height:30px;
  width:100px;
  float:right;
  padding:5px 15px 5px 15px;
  margin-top:10px;
  border:0px solid #000;
  background:var(--color1);
  color:#fff;
  line-height:20px;
  text-align:center;
}
</style>



// WEBPACK FOOTER //
// src/components/module/FwlcInfo1.vue